import React from "react";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Autocomplete,
} from "@mui/material";
import TextField from "@mui/material/TextField";

const Category = ({ value, onChange }) => {
  const categories = [
    "shrub",
    "tree",
    "groundcover",
    "herb",
    "grass",
    "climber",
    "fern",
    "orchid",
    "succulent",
    "aquatic",
    "vine",
    "palm",
    "bulb",
    "cyad",
    "epiphyte",
    "moss",
  ];

  return (
    <Box>
      <FormControl fullWidth>
        <InputLabel id="category-label">Category</InputLabel>
        <Autocomplete
          id="category"
          value={value}
          onChange={(event, newValue) => {
            onChange(newValue);
          }}
          options={categories}
          renderInput={(params) => <TextField {...params} label="Category" />}
        />
      </FormControl>
    </Box>
  );
};

export default Category;
